// https://ui.shadcn.com/docs/installation/manual
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export type NonEmptyArray<T> = [T, ...T[]]
export function isNonEmptyArray<T>(value: T[]): value is NonEmptyArray<T> {
  return value.length > 0
}
